import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NewPurchaseFormTsService } from '../../service/new-purchase-form.ts.service';
import { RegistrationData } from '../../../model/RegistrationData';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../main/header/header.component';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  formDisabled = false;

  form = new FormGroup({
    productId: new FormControl('', Validators.required),
    productName: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    company: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(30)]),
    nip: new FormControl(''), //, [Validators.minLength(10), Validators.maxLength(13)]),
    street: new FormControl('', Validators.required),
    zip: new FormControl('', [Validators.required, Validators.minLength(3)]),
    city: new FormControl('', Validators.required),
    country: new FormControl('', Validators.required),
    confirmation: new FormControl('', Validators.required),
    password: new FormControl('', [Validators.required, Validators.minLength(5)]),
    passwordRepeat: new FormControl('', [Validators.required, Validators.minLength(5)])
  });
  private registrationFormData: RegistrationData = {};

  constructor(
    private readonly router: Router,
    private readonly newPurchaseFormTsService: NewPurchaseFormTsService
  ) {
    this.newPurchaseFormTsService.currentFormData.subscribe(data => {
      if (data) {
        this.registrationFormData = data;
        console.log(`Received data: ${JSON.stringify(this.registrationFormData, null, 2)}`);
        this.form.patchValue({
          ...this.registrationFormData,
          country: 'PL'
        });
      }
    });
  }

  submit(): void {
    const registrationData = {
      ...this.registrationFormData,
      ...this.form.value
    };
    this.newPurchaseFormTsService.updateData(registrationData);
    console.log('Sending registration: ', JSON.stringify(registrationData, null, 2));
    this.router.navigate(['/payment']);
  }

  resetToHome(): void {
    this.router.navigate(['/']);
  }

  validateForm(): boolean {
    return true;
  }
}
